import type { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { styles } from '../index.styles';

export const SettingsGroup: FC<{ children: ReactNode; headline: string }> = ({
  children,
  headline,
}) => (
  <Box component="section" sx={styles.settingsGroup}>
    <Box sx={styles.settingsGroupHeader}>
      <Typography
        variant="h4"
        sx={(theme) => ({ color: theme.colors.neutral[700] })}
      >
        {headline}
      </Typography>
    </Box>
    <Box sx={styles.settingsGroupContent}>{children}</Box>
  </Box>
);
